import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Header from "@/components/Header";
import ServicesSection from "@/components/ServicesSection";
import ConsultationForm from "@/components/ConsultationForm";
import ContactDetails from "@/components/ContactDetails";
import Footer from "@/components/Footer";

export default function SeniorCarePage() {
  return (
    <div className="App bg-white min-h-screen" data-testid="senior-care-page">
      <Header />
      <main>
        {/* Page hero */}
        <section
          className="pt-36 pb-16 relative overflow-hidden"
          style={{
            background:
              "linear-gradient(180deg, #FFE5D9 0%, #FBF5F0 60%, #FFFFFF 100%)",
          }}
          data-testid="senior-care-hero"
        >
          <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <Link
              to="/"
              className="inline-flex items-center gap-2 text-sm text-[var(--gg-text-muted)] hover:text-[var(--gg-primary)] mb-8"
              data-testid="back-to-home"
            >
              <ArrowLeft size={16} /> Back home
            </Link>
            <div className="max-w-3xl">
              <span className="eyebrow">Senior Care</span>
              <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[var(--gg-deep)] mt-5 leading-[1.02] font-semibold text-balance">
                In-home care,
                <br />
                <em className="not-italic text-[var(--gg-primary)] font-normal">
                  brought quietly into every day.
                </em>
              </h1>
              <p className="mt-7 text-lg text-[var(--gg-text)] leading-relaxed max-w-2xl">
                Trained, background-checked caregivers who help seniors stay in
                their own home — with mobility support, meal preparation,
                housekeeping, and medical coordination tailored to the person,
                not the checklist.
              </p>
            </div>
          </div>
        </section>

        <ServicesSection />

        {/* CTA to relocation page */}
        <section className="py-20 bg-[var(--gg-cream)]" data-testid="cross-link-relocation">
          <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center">
            <span className="eyebrow">Also from Graceful Guidance</span>
            <h2 className="font-serif text-3xl md:text-4xl text-[var(--gg-deep)] mt-4 font-semibold">
              Coming home to Jamaica?
            </h2>
            <p className="mt-4 text-[var(--gg-text)] max-w-2xl mx-auto">
              For diaspora retirees and families managing property or a full
              relocation, see our Relocation &amp; Property Management services.
            </p>
            <Link
              to="/relocation"
              className="mt-8 inline-flex items-center gap-3 bg-[var(--gg-primary)] text-white hover:bg-[var(--gg-primary-dark)] transition-colors rounded-full pl-7 pr-3 py-3.5 text-sm"
              data-testid="link-to-relocation"
            >
              Explore Relocation
              <span className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center">
                <ArrowRight size={16} />
              </span>
            </Link>
          </div>
        </section>

        <ConsultationForm />
        <ContactDetails />
      </main>
      <Footer />
    </div>
  );
}
